import { FC, memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import { Menu, MenuButton, MenuItem, MenuList, MenuDivider, ButtonProps, Portal } from '@chakra-ui/react'

import { useAuthentication } from 'contexts/Authentication/Provider'
import { LogoutArrow, UserBadge } from 'components/icons'
import { Avatar } from 'components'
import GoToAuthenticationButton from '../GoToAuthenticationButton'
import { UNIFIED_LOGIN_URL, APP_CITIZEN_URL } from 'constants/urls'
import { ORIGIN_URL_QUERY } from 'constants/queryString'
import { encrypt } from 'utils/crypto'

type Props = {
  desconnectButtonProps?: ButtonProps
}

const UserButton: FC<Props> = ({ desconnectButtonProps }) => {
  const { push } = useRouter()
  const { user, logout } = useAuthentication()

  const pathToAuthenticator = useMemo(() => {
    return {
      pathname: UNIFIED_LOGIN_URL,
      query: { [ORIGIN_URL_QUERY]: encrypt(window.location.href) },
    }
  }, [])

  const handleLogout = async () => {
    await logout()
    push(pathToAuthenticator)
  }

  if (!user) return <GoToAuthenticationButton {...desconnectButtonProps} />

  return (
    <Menu>
      <MenuButton rounded="full">
        <Avatar size="sm" src={user.main_avatar_url} name={user.name} />
      </MenuButton>
      <Portal>
        <MenuList zIndex={999999}>
          <MenuItem onClick={() => push(APP_CITIZEN_URL)} icon={<UserBadge boxSize={5} />}>
            Conta
          </MenuItem>

          <MenuDivider />
          <MenuItem onClick={handleLogout} icon={<LogoutArrow boxSize={5} />}>
            Sair
          </MenuItem>
        </MenuList>
      </Portal>
    </Menu>
  )
}

export default memo(UserButton)
